module.exports = __webpack_public_path__ + "img/login-bg.e7b198b5.jpg";